const programAvailabilityTranslations = {
  title: "قم بملء النموذج.",
  description: "يرجى ملء النموذج لبدء إنشاء برنامج التغذية والتمارين الخاص بك.",
  action: "ملء النموذج",
};

export default programAvailabilityTranslations;
